export default "__VITE_ASSET__BhUORBni__"